import { render, staticRenderFns } from "./AuthMenuItem.vue?vue&type=template&id=2ca9ba42&scoped=true&"
import script from "./AuthMenuItem.vue?vue&type=script&lang=ts&"
export * from "./AuthMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./AuthMenuItem.vue?vue&type=style&index=0&id=2ca9ba42&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9ba42",
  null
  
)

export default component.exports